












import { defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'SocialContactButton',
  props: {
    activeFilters: {
      type: Number,
      default: 0
    }
  },
  components: { SfButton }
});
